import { format } from 'date-fns';

export const formatToISOLocalDate = (jsDate: Date | undefined | null) => {
  if (jsDate instanceof Date) {
    return format(new Date(jsDate), 'yyyy-MM-dd');
  }

  return null;
};
